define('home/views/ActivityCardReplyView',[
    'home/mixins/withReasonOld',

    'home/views/common/ActivityCardPostBaseView',
    'home/views/ActivityFooterReplyView',

    'home/templates/activityCardReply',
], function (
    withReason,

    ActivityCardPostBaseView,
    ActivityFooterReplyView,

    activityCardReplyTemplate
) {
    'use strict';

    var parent = ActivityCardPostBaseView;

    /**
     * Reply feed items can only have 1 reply activity. Groups of multiple replies
     * are treated as comments.
     */
    var ActivityCardReplyView = parent.extend({
        template: activityCardReplyTemplate,

        templateHelpers: function () {
            return {
                // Use the target for the 1 activity this item represents
                target: this.model.activities[0].target.toJSON(),
            };
        },

        createFooterView: function () {
            return new ActivityFooterReplyView({
                el: this.footerRegion.el,
                model: this.model,
            });
        },
    });


    var proto = ActivityCardReplyView.prototype;
    withReason.call(proto);

    return ActivityCardReplyView;
});

